module.exports = __webpack_public_path__ + "img/180h100_s_1_iz_3_povorotno_otkidnoy_centralnoy_chastyu.463810d4.svg";